import React from 'react';
import FeaturedVehiclesSlides from './featuredVehiclesSlides';

export default () => (
  <section className="section-carousel">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h2 className="ui-title">
            {startup.dictionary.Featured}
            <span className="text-primary">{` ${startup.dictionary.Vehicles}`}</span>
          </h2>
        </div>
      </div>
    </div>
    <div className="section-carousel__inner bg-dark">
      <div
        className="js-slider"
        data-slick='{"slidesToShow": 5,  "slidesToScroll": 5, "infinite": true, "responsive": [{"breakpoint": 1800, "settings": {"slidesToShow": 4, "slidesToScroll": 4}}, {"breakpoint": 1400, "settings": {"slidesToShow": 3, "slidesToScroll": 1}}, {"breakpoint": 1040, "settings": {"slidesToShow": 2, "slidesToScroll": 1}}, {"breakpoint": 767, "settings": {"slidesToShow": 1, "slidesToScroll": 1}}]}'
      >
        <FeaturedVehiclesSlides />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-12 d-flex justify-content-center">
            <a
              className="section-carousel__btn btn btn-primary"
              href={`./${startup.language}/catalog`}
            >
              <i className="ic icon-list" />{' '}
              {startup.content.ViewAllCarsListings}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);
